import React, { useContext, useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom';

import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { ArrowBack } from '@mui/icons-material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CountryContext from './country_context';
import Profile_pic from './images/profile-avatar.png'
import LogoutIcon from '@mui/icons-material/Logout';
import { Logout } from './firebase';




export const ProfileNavMobile = (props) => {
    const context = useContext(CountryContext)
    let textColor = "text-dark"

    props.color == "white" ? textColor = "text-white" : textColor = "text-dark"

    useEffect(()=> {
        console.log(
            props.color
        )
    })
    return (
        <div className='w-100'>
            <Navbar bg="" expand="lg">
                <Navbar.Toggle className='ml-auto' aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" className='w-100'>
                    <Nav className="text-dark row justify-content-between">
                        <Link to="/home" className={`${textColor} pb-2 pt-4  `}>
                                <HomeOutlinedIcon />

                            </Link>

                            <Link to="/my_dogs" className={`${textColor} pb-2 pt-4  `}>My Dogs</Link>


                            <Link to="/profile/account" className={`${textColor} pb-2 pt-4  `}>Account</Link>

                            {context.allowedAdminUser &&

                                <Link to="/admin" className='text-dark  pt-4  '>Admin</Link>}

                            <span className='pt-4  '>
                                {context.user_sql_details && context.user_sql_details.public_id ?
                                    <img src={`https://res.cloudinary.com/daurieb51/image/upload/${context.user_sql_details.public_id}.png`}
                                        className='  img-fluid profile_pic_user2
                                        '
                                    />
                                    :
                                    <img src={Profile_pic}
                                        className='  img-fluid profile_pic_user2 '
                                    />
                                }
                            </span>

                            <Link to="/login" className={`${textColor} pb-2 pt-4 mb-5 `}
                            onClick={Logout}
                          >
                                <LogoutIcon /> Logout</Link>

                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
    )
}